import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navLinks } from '@/mocks/site';

function todayText() {
  const d = new Date();
  return `${d.getFullYear()} 年 ${d.getMonth() + 1} 月 ${d.getDate()} 日`;
}

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="hidden lg:block border-b border-background-200 bg-background-100">
        <div className="container-page flex items-center justify-between h-9 text-xs text-foreground-500">
          <p className="flex items-center gap-2">
            <span className="w-3.5 h-3.5 flex items-center justify-center text-primary-500">
              <i className="ri-flashlight-line"></i>
            </span>
            热料核实情报站 · 第 214 期 · {todayText()}
          </p>
          <div className="flex items-center gap-5">
            <Link to="/debunk" className="hover:text-primary-600 transition-colors">
              今日新增辟谣 4 条
            </Link>
            <Link to="/about" className="hover:text-primary-600 transition-colors">
              投稿与纠错
            </Link>
          </div>
        </div>
      </div>

      <div className="container-page flex items-center justify-between h-16 md:h-[72px]">
        <Link to="/" className="flex items-center gap-2.5 shrink-0">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-radar-line text-lg"></i>
          </span>
          <span className="leading-none">
            <span className="block font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-tight">
              看料爆料
            </span>
            <span className="hidden sm:block text-[11px] text-foreground-500 mt-1 tracking-wide">
              真假核实 · 实锤追踪 · 辟谣速递
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/ranking"
            className="hidden sm:inline-flex items-center gap-2 rounded-md border border-background-300 px-3.5 py-2 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line"></i>
            </span>
            查一条料
          </Link>
          <Link
            to="/about#submit"
            className="hidden sm:inline-flex items-center rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            投稿爆料
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <nav aria-label="移动端导航" className="container-page flex flex-col py-2">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-2 py-3 rounded-md text-base font-medium border-b border-background-100 last:border-b-0 ${
                    isActive ? 'text-primary-600' : 'text-foreground-800'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/about#submit"
              onClick={() => setMenuOpen(false)}
              className="mt-3 mb-2 inline-flex items-center justify-center rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              投稿爆料 / 纠错
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}